module.exports = __webpack_public_path__ + "static/media/success.e6f83ec8.png";